import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _, { findIndex as _findIndex, forEach as _forEach } from 'lodash';
import ReactImageMagnify from '@ditus/react-image-magnify';

import { getNameInCurrentLanguage, getDescriptionInCurrentLanguage } from 'helpers/intl';
import { ROLE_ROOT_EMPLOYEE, ROLE_WL_ADMIN, S3_LINKS_DIV } from 'js/constants';
import Loader from '../Loader';
import List from '../../List';
import may from '../../../security';

class CategoryItems extends React.Component {
  getUrlData = () => {
    const { category } = this.props;
    const urlData = { category: category.path };
    return urlData;
  };

  selectCategoryItem = (templateId, itemId, itemName, itemDirectOrdering) => {
    this.props.selectItem(templateId, itemId, itemName, itemDirectOrdering);
    const elmnt = document.getElementsByClassName('edition-settings');
    elmnt[0].scrollIntoView();
  };

  render() {
    const {
      appIntl,
      list,
      selectedItem,
      user,
      intl: { messages },
    } = this.props;

    return (
      <>
        {list.pending ? (
          <Loader />
        ) : (
          list.data.list.map(item => {
            let itemName;
            typeof item?.name === 'object'
              ? (itemName = getNameInCurrentLanguage(item?.name, appIntl))
              : (itemName = item?.name);
            let variationIndex = null;
            let variationIndexLarged = null;
            if (item.default_img) {
              variationIndex = _findIndex(item.default_img.variations, { variation_type: 'thumb' });
              variationIndexLarged = _findIndex(item.default_img.variations, { variation_type: 'web' });
            }
            let itemActive = '';
            if (selectedItem === item.template_id) {
              itemActive = ' active';
            }
            let itemImg = item.default_img
              ? item.default_img.variations[variationIndex].file.web_link
              : S3_LINKS_DIV.ITEM_IMGS_THUMB_DEFAULT;
            let itemImgLarged = item.default_img
              ? item.default_img.variations[variationIndexLarged].file.web_link
              : S3_LINKS_DIV.ITEM_IMGS_THUMB_DEFAULT;
            const itemIndex = !item.assets
              ? -1
              : _findIndex(item.assets.imgs, function(o) {
                  return o.owner.id === item.template_client;
                });
            if (itemIndex >= 0) {
              variationIndex = _findIndex(item.assets.imgs[itemIndex].variations, { variation_type: 'thumb' });
              itemImg = item.assets.imgs[itemIndex].variations[variationIndex].file.web_link;
              variationIndexLarged = _findIndex(item.assets.imgs[itemIndex].variations, { variation_type: 'web' });
              itemImgLarged = item.assets.imgs[itemIndex].variations[variationIndexLarged].file.web_link;
            }


            const productOutput = [];
            let outputVariant = '';
            let url = '';

            _forEach(item.attributes, function(item1) {
              _forEach(item1.name, function(item2) {
                if (item2.name === 'Verlinkung') {
                  outputVariant = 'output_link';
                  _forEach(item1.values, function(item3) {
                    url = item3.value[0].name;
                  });
                }
              });
            });

            if (outputVariant === 'output_link') {
              productOutput.push(
                <Link key={itemName} className={'item-selection' + itemActive} to={{ pathname: url }} target="_blank">
                  <div>
                    <div className="preview">
                      <img src={itemImg} alt={itemName} />
                    </div>
                    <div className="product-info">
                      <h5>{itemName}</h5>
                      <p
                        className="item-name"
                        dangerouslySetInnerHTML={{ __html: getDescriptionInCurrentLanguage(item.description, appIntl) }}
                      />
                      <p>{url}</p>
                    </div>
                  </div>
                </Link>
              );
            } else {
              productOutput.push(
                <div
                  key={`${item.id}_${item.template_id}`}
                  className={'item-selection' + itemActive}
                  onClick={() => {
                    this.selectCategoryItem(item.template_id, item.id, itemName, item?.template_direct_ordering);
                  }}
                >
                  <div className="preview">
                    {item?.template_direct_ordering ? (
                      <ReactImageMagnify
                        {...{
                          smallImage: {
                            alt: itemName,
                            isFluidWidth: true,
                            src: itemImg,
                          },
                          largeImage: {
                            src: itemImgLarged,
                            width: 800,
                            height: 800,
                          },
                          enlargedImagePosition: 'over',
                          enlargedImageClassName: 'larged-item-image',
                          className: 'zoom-item-image-container',
                          }
                        }
                      />
                    ) : (
                      <img src={itemImg} alt={itemName} />
                    )}
                  </div>
                  <div className="product-info">
                    <h5>
                      <span>{itemName}</span>
                      <span>
                        {item?.template_direct_ordering && (
                          <>
                            <i className="fal fa-cart-arrow-down" /> ({messages.direct_ordering_label})
                          </>
                        )}
                      </span>
                    </h5>
                    <p
                      className="item-name"
                      dangerouslySetInnerHTML={{ __html: getDescriptionInCurrentLanguage(item.description, appIntl) }}
                    />
                    { item.listing_price > 0 && (
                      <p className="item-name">{(item.listing_price ?? 0.00) + ' €'} / {(item.listing_pieces ?? 0)} {messages.categoryitems_stock}</p>
                    )}
                    {item.attributes &&
                      item.attributes.map(attribute => {
                        /* To understand..
                          Due to incomplete datasets, a double index search is necessary.
                          The cause is not yet clear.
                          The first index query searches the "value", the second the "name".
                          If the data exists, the condition in the if statement is true.
                          But then the dataset whose lang matches the local value is displayed.
                          If this does not match, it takes the existing dataset lang === null or undefined.
                          Even if the cause can be fixed. There are still incomplete datasets in older pruduct attributes.
                        */

                        let index = _.findIndex(attribute?.values?.[0]?.value, value => value?.lang === appIntl.locale);
                        if (index === -1) {
                          index = _.findIndex(attribute?.name, name => name?.lang === appIntl.locale);
                        }
                        if (
                          attribute?.values[0]?.value &&
                          attribute?.values[0]?.value[index] &&
                          attribute?.values[0]?.value[index]?.name &&
                          attribute?.values[0]?.value[index]?.name !== '0'
                        ) {
                          return (
                            <p className="item-attribute">
                              <span>{getNameInCurrentLanguage(attribute.name, appIntl)}: </span>
                              <span>
                                {getNameInCurrentLanguage(attribute.name, appIntl) === 'Vergünstigte Umsatzsteuer' ||
                                getNameInCurrentLanguage(attribute.name, appIntl) === 'Vergünstigte Umsatzsteuer '
                                  ? 'Verfügbar'
                                  : getNameInCurrentLanguage(attribute.values[0].value, appIntl)}
                              </span>
                            </p>
                          );
                        }
                        return null;
                      })}

                    {may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
                      <>
                        <p className="item-attribute">
                          <span>{messages.categoryitems_customer} </span>
                          <span>
                            {item?.template_company?.profile?.company} ({item.template_client})
                          </span>
                        </p>
                      </>
                    ) : null}
                    {may(ROLE_ROOT_EMPLOYEE, user.roles) || may(ROLE_WL_ADMIN, user.roles) ? (
                      <>
                        <p className="item-attribute">
                          <span>{messages.categoryitems_template}</span>
                          <span>{item.template_name}</span>
                        </p>
                      </>
                    ) : null}
                  </div>
                </div>
              );
            }

            return productOutput;
          })
        )}
        <List listName="items" url="/api/webshop/items.json" list={list} urlData={this.getUrlData()} noRender />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.items, // edit
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(CategoryItems)));
